import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user already accepted cookies
    const hasConsent = Cookies.get('cookie-consent');
    
    if (!hasConsent) {
      // Show popup 
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 120000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    // Set cookie for 30 days
    Cookies.set('cookie-consent', 'accepted', { expires: 30 });
    setShowConsent(false);
  };

  const declineCookies = () => {
    // Set cookie to remember user declined
    Cookies.set('cookie-consent', 'declined', { expires: 7 });
    setShowConsent(false);
  };

  const customizeCookies = () => {
    // This would typically open a more detailed cookie preferences modal
    // For now, we'll just set a basic cookie
    Cookies.set('cookie-consent', 'customized', { expires: 30 });
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <AnimatePresence>
      {showConsent && (
        <motion.div
          initial={{ x: -300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -300, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-4 left-4 z-50 max-w-md bg-white rounded-lg shadow-lg overflow-hidden"
        >
          <div className="p-6 space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 flex-shrink-0">
                <img 
                  src="/bucket/avatar.png" 
                  alt="Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold">Bienvenue sur le site Web de</h3>
                <h2 className="text-xl font-bold">Mopaossi</h2>
              </div>
            </div>
            
            <p className="text-sm text-gray-600">
              On a attendu d'être sûrs que le contenu de ce site vous intéresse avant de vous déranger, 
              mais on aimerait bien vous accompagner pendant votre visite...
            </p>
            <p className="text-sm text-gray-600">C'est OK pour vous ?</p>
            
            <p className="text-sm text-gray-500">
              Pour modifier vos préférences par la suite, cliquez sur le lien 'Préférences de cookies' 
              situé dans le pied de page.
            </p>
            
            <div className="border-t pt-4">
              <h4 className="font-semibold mb-2">Voici pourquoi nous utilisons des cookies.</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>- Partager des données d'analyse, de l'utilisateur et de personnalisation avec Google</li>
                <li>- Mesure d'audience & Analytics</li>
              </ul>
            </div>
            
            <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2 justify-between">
              <Button 
                variant="outline" 
                className="bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-800 hover:to-blue-950 text-white px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300" 
                onClick={declineCookies}
              >
                Non merci
              </Button>
              <Button 
                variant="outline" 
                className="bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-800 hover:to-blue-950 text-white px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300" 
                onClick={customizeCookies}
              >
                Modifier
              </Button>
              <Button 
                className="bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-800 hover:to-blue-950 text-white px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300" 
                onClick={acceptCookies}
              >
                D'accord
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;